import useReservationsAdd from '../../operations/client/useReservationAdd';
import { BasketDrawer } from './BasketDrawer';
import { ClientView } from './ClientView';
import { EnrollmentFailureInfo } from './EnrollmentFailureInfo';
import { EnrollmentSuccessInfo } from './EnrollmentSuccessInfo';
import { Flex } from '@chakra-ui/react';
import { pushDataLayerEvent } from '../../analytics';
import { setDocumentTitle } from '../../utils/documentTitle';
import { SlotsSelection } from './SlotsSelection';
import { SummaryView } from './SummaryView';
import { useEffect } from 'react';
import { useEnrollment } from './EnrollmentContext';
import { useFirebaseAuth } from '../../hooks/useFirebaseAuth';
import { useUser } from '../../hooks/useUser';
import { useUserClaims } from '../../hooks/useUserClaims';

export const EnrollmentPage = () => {
	useEffect(setDocumentTitle('Zapisy')); // eslint-disable-line react-hooks/exhaustive-deps

	const auth = useFirebaseAuth();
	const [user] = useUser();
	const [userClaims, userClaimsLoading, userClaimsError] = useUserClaims(auth);
	const {
		step,
		lessonsList,
		notes,
		client,
		statuteAccepted,
		setStep,
		goToNextStep,
		setLessonsList,
		setNotes,
		setClient,
		setStatuteAccepted,
		clearPersistedState,
		isBasketOpen,
		closeBasket,
	} = useEnrollment();
	const enrollment = useReservationsAdd({
		onSuccess: async () => {
			clearPersistedState();
			pushDataLayerEvent('reservation_complete');
			setStep(3);
		},
	});

	return (
		<>
			<Flex direction="column" flexGrow="1" mx={{ base: '4%', md: '10%' }}>
				{step === 0 && <SlotsSelection />}
				{step === 1 && <ClientView onStepFinish={goToNextStep} setClient={setClient} />}
				{step === 2 && (
					<SummaryView
						user={user}
						client={client}
						notes={notes}
						setNotes={setNotes}
						lessonsList={lessonsList}
						statuteAccepted={statuteAccepted}
						setStatuteAccepted={setStatuteAccepted}
						onSubmit={() => {
							if (userClaimsLoading || userClaimsError) {
								return;
							}
							enrollment.mutate({
								clientId: userClaims!.id as string,
								uid: user!.uid,
								notes: notes ?? undefined,
								lessons: lessonsList.map((lesson: any) => ({
									slot: lesson.id,
									student: lesson.student,
									notes: lesson.notes,
								})),
							});
						}}
						isSending={enrollment.isPending}
					/>
				)}
				{step === 3 && <EnrollmentSuccessInfo />}
			</Flex>

			<EnrollmentFailureInfo
				isOpen={enrollment.isError}
				onClose={enrollment.reset}
			/>
			<BasketDrawer
				lessonsList={lessonsList}
				setLessonsList={setLessonsList}
				onClose={closeBasket}
				isOpen={isBasketOpen}
			/>
		</>
	);
};
